import { Button, Modal, Row } from "react-bootstrap";
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { MySelect } from "../../ui/controls/MySelect";
import { MyTextInput } from "../../ui/controls/MyTextInput";
import { onlyIntegers, onlyIntegersDecimals } from "../../../helpers/numericFields";
import { useSelector, useDispatch } from 'react-redux';
import { deleteLodgingGroupRoomCategory, editLodgingGroupRoomCategory } from "../../../store/slices/groupFiles/thunks";
import { MyTextInput66 } from "../../ui/controls/MyTextInput66";
import { MyTextLabel66 } from "../../ui/controls/MyTextLabel66";
import { useEffect } from "react";
import { setRoomCategoryList } from "../../../store/slices/catalogue/catalogueSlice";
import { getRoomCategoryList } from "../../../store/slices/catalogue/thunks";

export const EditLodgingRoomCategory = ({ lodgingGroupRoomCategory, groupFile, lodging, isOpen, setIsOpen }) => {
  const dispatch = useDispatch();
  const { lodgingGroupList } = useSelector((state) => state.groupFiles);
  const { roomCategoryList } = useSelector((state) => state.catalogue);

  useEffect(() => {

    if (lodgingGroupRoomCategory == null || lodgingGroupRoomCategory.idLodgingGroup == null) {
      return;
    }

    dispatch(getRoomCategoryList(lodgingGroupList.find(item => item.id === lodgingGroupRoomCategory.idLodgingGroup).idHotel));
  
      return () => {
        dispatch(setRoomCategoryList([]))
      }
    }, [lodgingGroupRoomCategory.idLodgingGroup, lodgingGroupList, dispatch]);

  const delete2 = () => {
    const success = () => {
      setIsOpen(false)
    }
    dispatch(deleteLodgingGroupRoomCategory(lodgingGroupRoomCategory.id, groupFile.id, success));
  }

  return (
    <>
      <Modal
        size="xl"
        show={isOpen}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title >
            Editar Categoria
          </Modal.Title>
          <Button
            onClick={() => setIsOpen(false)}
            className="btn-close"
            variant=""
          >
            x
          </Button>
        </Modal.Header>

        <Formik
          initialValues={{
            lodging: { value: lodging.id, label: lodging.name },
            roomCategory: { value: lodgingGroupRoomCategory.idRoomCategory, label: lodgingGroupRoomCategory.roomCategory },
            quantity: lodgingGroupRoomCategory.quantity,
          }}
          onSubmit={(({ lodging, roomCategory, quantity }, { resetForm, setErrors }) => {

            if (!lodging) {
              return setErrors({ "lodging": "Requerido" })
            }

            if (!roomCategory) {
              return setErrors({ "roomCategory": "Requerido" })
            }

            const success = () => {
              resetForm();
              setIsOpen(false)
            }

            dispatch(editLodgingGroupRoomCategory(lodgingGroupRoomCategory.id, roomCategory.value, quantity, groupFile.id, success));
          })}
          validationSchema={
            Yup.object({
              quantity: Yup.number()
                .required("Requerido"),
            })
          }
        >

          {
            ({ setFieldValue }) => (
              <Form>
                <Modal.Body>
                  <Row>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MySelect label='Hospedaje:*' name="lodging" options={
                          lodgingGroupList.map(item => ({ "value": item.id, "label": item.hotel }))
                        } mode='horizontal'
                          singleSelect="true"
                          onChange={e => {
                            setFieldValue("lodging", e);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MySelect label='Categoria de Habitacion:*' name="roomCategory" options={
                          roomCategoryList.map(item => ({"value":item.id, "label": item.name}))
                        } mode='horizontal'
                          singleSelect="true"
                          onChange={e => {
                            setFieldValue("roomCategory", e);
                          }} />
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='Cantidad:' name='quantity' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegers(e)) {
                              return
                            }
                            setFieldValue("quantity", e.target.value);
                          }} />
                      </div>
                    </div>
                  </Row>
                  <div style={{ fontSize: 13 }}>* Dato obligatorio</div>
                </Modal.Body>

                <Modal.Footer>
                  <div style={{ width: "100%" }}>
                    <Button variant="danger" type="button" style={{ float: "left" }} onClick={delete2}>
                      Eliminar
                    </Button>
                    <Button variant="primary" type="submit" style={{ float: "right" }}>
                      Guardar Informacion
                    </Button>
                  </div>
                </Modal.Footer>
              </Form>
            )
          }
        </Formik>


      </Modal>
    </>
  )
}
